import { mapActions, mapGetters } from 'vuex'
import { cvtRouteNodes } from "@/js/utils/routes"
import * as actions from '../../../../store/modules/actions';

export default {
  components: {},
  props: {},
  data() {
    return {
      cvtRouteNodes
    }
  },
  created(){
    const payload = {
      key: "CURRENT_STAGE",
      value: "integrate_builder"
    }
    this.updateConfig(payload)
  },
  methods: {
    ...mapActions({
      upsertFeatureConfig: actions.CREATE_FEATURE_CONFIG,
    }),
    async updateConfig(config: { key: String; value: String }) {
      try {
        const payload = {
          key: config.key,
          table: 'organizationConfigs',
          value: config.value,
        }
        await this.upsertFeatureConfig(payload)
      } catch (err) {
        console.log(err)
      }
    },
    navigateToNamedRoute(namedRoute: String): void {
      this.$router.push({
        name: namedRoute,
      });
    },
  },
}
